/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBarcode = createReactComponent("barcode", "IconBarcode", [
  ["path", { d: "M4 7v-1a2 2 0 0 1 2 -2h2", key: "svg-0" }],
  ["path", { d: "M4 17v1a2 2 0 0 0 2 2h2", key: "svg-1" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v1", key: "svg-2" }],
  ["path", { d: "M16 20h2a2 2 0 0 0 2 -2v-1", key: "svg-3" }],
  ["path", { d: "M5 11h1v2h-1z", key: "svg-4" }],
  ["path", { d: "M10 11l0 2", key: "svg-5" }],
  ["path", { d: "M14 11h1v2h-1z", key: "svg-6" }],
  ["path", { d: "M19 11l0 2", key: "svg-7" }]
]);

export { IconBarcode as default };
//# sourceMappingURL=IconBarcode.js.map
